import { render, staticRenderFns } from "./allsixth.vue?vue&type=template&id=11057ffe&scoped=true"
import script from "./allsixth.vue?vue&type=script&lang=js"
export * from "./allsixth.vue?vue&type=script&lang=js"
import style0 from "./allsixth.vue?vue&type=style&index=0&id=11057ffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11057ffe",
  null
  
)

export default component.exports